import { Box } from '@mui/material'
import { IFilterComponentProps } from 'components/Table/TableFilter/types'
import dayjs from 'dayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { dateFilterContainer, inputStyles } from '../Inputs.style'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

function DateFilterInput({
  value,
  columnId,
  handleFilterState,
  startAdornment,
}: IFilterComponentProps) {
  return (
    <Box sx={dateFilterContainer}>
      <DatePicker
        value={!!value ? dayjs(value) : null}
        onChange={(date) => {
          handleFilterState(columnId, null, date?.utc(true).toDate() ?? '')
        }}
        format="DD/MM/YYYY"
        slotProps={{
          textField: {
            fullWidth: true,
            variant: 'standard',
            InputProps: { startAdornment },
            sx: inputStyles,
          },
        }}
      />
    </Box>
  )
}

export default DateFilterInput
